import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20lifestyle%20scene%20with%20carefully%20arranged%20fashion%20accessories%20and%20modern%20gadgets%20on%20a%20light%20wooden%20surface%2C%20gentle%20morning%20sunlight%20streaming%20through%20sheer%20linen%20curtains%2C%20coral%20and%20cream%20color%20palette%20with%20sage%20green%20accents%2C%20peaceful%20Scandinavian%20aesthetic%20with%20organic%20textures%2C%20shallow%20depth%20of%20field%20creating%20dreamy%20atmosphere&width=1800&height=1200&seq=hero-bg-kakobuy-v2-2026&orientation=landscape"
        alt="Kakobuy Spreadsheet Polska"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/20"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight">
          {t("hero.title")}
        </h1>
        <p className="text-base md:text-lg text-white/90 mb-3 md:mb-4 max-w-2xl mx-auto leading-relaxed">
          {t("hero.subtitle")}
        </p>
        <p className="text-sm md:text-base text-white/80 mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed">
          {t("hero.description")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 md:mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
          >
            {t("hero.cta_primary")}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold text-white border-2 border-white/60 hover:border-white hover:bg-white/10 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t("hero.cta_secondary")}
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-white/80">
          <span className="flex items-center gap-1.5 text-xs md:text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400 text-base"></i>
            {t("hero.trust_1")}
          </span>
          <span className="flex items-center gap-1.5 text-xs md:text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400 text-base"></i>
            {t("hero.trust_2")}
          </span>
          <span className="flex items-center gap-1.5 text-xs md:text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400 text-base"></i>
            {t("hero.trust_3")}
          </span>
          <span className="flex items-center gap-1.5 text-xs md:text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400 text-base"></i>
            {t("hero.trust_4")}
          </span>
        </div>
      </div>
    </section>
  );
}